import React, { useEffect, useRef as _useRef } from 'react'
import { useState } from 'react'
import { AssetDistribution } from './AssetDistribution'
import './index.less'
import { DynastyDistribution } from './DynastyDistribution'
import { WorkDistribution } from './WorkDistribution'
import { AuthorDistribution } from './AuthorDistribution'
import { getDataOverviewMetadata } from '@/server'
import { useAppDispatch, useAppSelector } from '@/hooks'
import { useNavigate } from 'react-router-dom'
import { setToken } from '@/features/Login/login'

//数据概览
export function DashboardPage() {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const token = useAppSelector((state) => state.login.token)
  const [_footerRightCom, _setFooterRightCom] = useState(0)
  const [footerLeftCom, setFooterLeftCom] = useState(0)
  const [metadata, setMetadata] = useState<{
    workNum: number
    imageNum: number
    authorNum: number
    instituteNum: number
    commentNum: number
    commentLength: number
  }>({
    workNum: 0,
    imageNum: 0,
    authorNum: 0,
    instituteNum: 0,
    commentNum: 0,
    commentLength: 0
  })
  // 获取首栏数据
  useEffect(() => {
    getDataOverviewMetadata(token).then((res) => {
      if (res.data.code === '10056') {
        //token失效
        window.confirm('登录已过期，请重新登录！')
        dispatch(setToken(''))
        navigate('/')
      } else {
        setMetadata(res.data.content)
      }
    })
  }, [])
  return (
    <>
      <div className='head-area'>
        <div className='head-area-box'>
          <div className='head-area-title'>作品数量</div>
          <div className='head-area-data'>
            <div className='head-area-num'>
              {String(metadata.workNum).replace(/(\d)(?=(\d{3})+$)/g, '$1,')}
            </div>
            <div className='head-area-unit'>件</div>
          </div>
          <div className='head-area-info'>i</div>
        </div>
        <div className='head-area-box'>
          <div className='head-area-title'>图片数量</div>
          <div className='head-area-data'>
            <div className='head-area-num'>
              {String(metadata.imageNum).replace(/(\d)(?=(\d{3})+$)/g, '$1,')}
            </div>
            <div className='head-area-unit'>件</div>
          </div>
          <div className='head-area-info'>i</div>
        </div>
        <div className='head-area-box'>
          <div className='head-area-title'>作者数量</div>
          <div className='head-area-data'>
            <div className='head-area-num'>
              {String(metadata.authorNum).replace(/(\d)(?=(\d{3})+$)/g, '$1,')}
            </div>
            <div className='head-area-unit'>位</div>
          </div>
          <div className='head-area-info'>i</div>
        </div>
        <div className='head-area-box'>
          <div className='head-area-title'>藏馆数量</div>
          <div className='head-area-data'>
            <div className='head-area-num'>
              {String(metadata.instituteNum).replace(/(\d)(?=(\d{3})+$)/g, '$1,')}
            </div>
            <div className='head-area-unit'>个</div>
          </div>
          <div className='head-area-info'>i</div>
        </div>
        <div className='head-area-box'>
          <div className='head-area-title'>作品品评</div>
          <div className='head-area-data-workcomment'>
            <div className='head-area-num-workcomment'>
              {String(metadata.commentNum).replace(/(\d)(?=(\d{3})+$)/g, '$1,')}
            </div>
            <div className='head-area-unit-workcomment'>条</div>
          </div>
          <div className='head-area-data-workcomment'>
            <div className='head-area-num-workcomment'>
              {String(metadata.commentLength).replace(/(\d)(?=(\d{3})+$)/g, '$1,')}
            </div>
            <div className='head-area-unit-workcomment'>字</div>
          </div>
          <div className='head-area-info'>i</div>
        </div>
      </div>
      <div className='foot-area'>
        <div className='left-area'>
          <div className='area-header'>
            <button
              onClick={() => setFooterLeftCom(0)}
              className={
                'area-header-button' + (footerLeftCom === 0 ? ' area-header-button-checked' : '')
              }
            >
              作品分布
            </button>
            <button
              onClick={() => setFooterLeftCom(1)}
              className={
                'area-header-button' + (footerLeftCom === 1 ? ' area-header-button-checked' : '')
              }
            >
              作者分布
            </button>
          </div>
          {footerLeftCom === 0 ? <WorkDistribution /> : <AuthorDistribution />}
        </div>
        <div className='right-area'>
          <div className='mid-area-header mid-area-header-1'>资产分布</div>
          <div className='right-area-content'>
            <AssetDistribution />
          </div>
        </div>
      </div>
      <div className='mid-area'>
        <div className='mid-area-header-container'>
          <div className='mid-area-header'>朝代数据概览</div>
        </div>
        <div className='mid-area-content'>
          <DynastyDistribution />
        </div>
      </div>
    </>
  )
}
